var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0C5.14342 0 0 5.14387 0 11.5C0 17.8566 5.14387 23 11.5 23C17.8566 23 23 17.8561 23 11.5C23 5.14342 17.8561 0 11.5 0ZM11.5 21.2031C6.13664 21.2031 1.79688 16.863 1.79688 11.5C1.79688 6.13664 6.137 1.79688 11.5 1.79688C16.8634 1.79688 21.2031 6.137 21.2031 11.5C21.2031 16.8634 16.863 21.2031 11.5 21.2031Z",
    fill: "#7E8392"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.62695C11.0038 9.62695 10.6016 10.0292 10.6016 10.5254V16.311C10.6016 16.8072 11.0038 17.2095 11.5 17.2095C11.9962 17.2095 12.3984 16.8072 12.3984 16.311V10.5254C12.3984 10.0292 11.9962 9.62695 11.5 9.62695Z",
    fill: "#7E8392"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.502 8.52734C12.1718 8.52734 12.7148 7.98431 12.7148 7.31445C12.7148 6.64459 12.1718 6.10156 11.502 6.10156C10.8321 6.10156 10.2891 6.64459 10.2891 7.31445C10.2891 7.98431 10.8321 8.52734 11.502 8.52734Z",
    fill: "#7E8392"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoicon);
export default __webpack_public_path__ + "static/media/infoicon.9b97bf382f151ca4e10b8e9025a9fb1d.svg";
export { ForwardRef as ReactComponent };